"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const express_proxy_client_1 = require("../../../src-common/model/express-proxy-client");
console.log("asd store !!!!!..");
let win = window;
/*
async function testProxy() {
  // TODO: TEMPPII ... TESTAA NETLIFYLLÄ ... proxycall omaks endpointiks ... opettele sourcemap ... kato ettei serverikoodia tuu bundleihin! ... miks toi store._initData ei päivity??? ... tai napit toimi??? ... mites vue ts
  try {
    console.log("asd proxy... serviceBaseurl: "+serviceBaseurl);
    //let akservice = await createClientAkServiceProxy("/api/irgen"); toimii vain devissä ei mee netlify service_handler kautta
    let service = await createClientServiceProxy(serviceBaseurl, "project_service") as project_service;
    console.log("asd proxy service: ",service);
    let asd = await service.proxytest("foo");
    console.log("asd proxy test: "+asd);
  } catch (e) {
    console.error("asd proxy test error: ",e);
    throw e;
  }
}
if (win.location) testProxy();
 */
var state = {
    project: null,
    projectId: null,
    setProject(projectId) {
        console.log("...state.setProject, projectId: " + projectId);
        win.history.replaceState(undefined, undefined, win.replaceQueryParam("project", projectId));
        console.log("...state.setProject, store: ", store);
        this.project = store.projectsPanel.projects.find(p => p.projectId === projectId);
        if (projectId && !this.project) {
            alert("no project: " + projectId);
            // TODO: ennemmin joku yleinen error käsittely ja joku tätä kutsuu, pitäiskö olla linkattu jonkun komponentin mountediin esim
        }
        this.projectId = this.project ? this.project.projectId : undefined;
        console.log("...state.setProject, project: ", this.project);
    }
};
let projectService;
// gener: start store
var store = {
    asyncInitVueApp() {
        return __awaiter(this, void 0, void 0, function* () {
            let serviceBaseurl = "/.netlify/functions/service_handler/" + win._akm.p + ""; //
            projectService = (yield express_proxy_client_1.createClientServiceProxy(serviceBaseurl, "project_service"));
        });
    },
    ___asd: "asd",
    _initData: function () {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: purkka mut tätä tarttetaan ennen mitään muuta
            state.projectId = win.getUrlParam("project");
            store.userPanel.currentUserName = win.getUrlParam("user");
            // ladataan kaikki alussa tarvittava
            //this.projectsPanel.projects = await win.callService("project_service", "findProjects", {user: store.userPanel.currentUserName});
            this.projectsPanel.projects = yield projectService.findProjects({ user: store.userPanel.currentUserName });
            this.userTasksPanel.userName = store.userPanel.currentUserName;
            //this.userTasksPanel.userAllTasks = await win.callService("project_service", "findUserAllTasks", {user: store.userPanel.currentUserName});
            this.userTasksPanel.userAllTasks = yield projectService.findUserAllTasks({ user: store.userPanel.currentUserName });
            this.userTasksPanel.userAllTasks.forEach(t => t.name += " @" + t.assigneeFirstName + ""); // assignee mukaan nimeen
            // settaillaan juttuja mm parametrien mukaan
            state.setProject(state.projectId);
            console.log(" *** TROLO initData asd *** store._initData... state.projectId: " + state.projectId + ", current user: " + store.userPanel.currentUserName + " TRACE: ", new Error("!!TRACE!!"));
        });
    },
    state: state,
    userPanel: {
        "useAsUsers": [{ firstName: "Samuli" }, { firstName: "Antti" }, { firstName: "Klaus" }, { firstName: "Mikko" }, { firstName: "Sami" }, { firstName: "Kalle" }],
        "currentUserName": "Samuli",
        "ButtonChangeUseAs_selectUseAsUser_firstName": (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            //alert("USE: "+JSON.stringify(item));
            store.userPanel.currentUserName = item.firstName;
            win.history.replaceState(undefined, undefined, win.replaceQueryParam("user", item.firstName)); // TODO: joku järki urlparam
            console.log("ChangeUseAs_selectUseAsUser_firstName, new use as: " + item.firstName);
            //await store._initData(); // reload projects
            window.location.reload(); // vitut ku reload koko sivu
        })
    },
    projectsPanel: {
        "projects": null,
        "ButtonOpenProject_name": function (evt, item) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log(" *** projectsPanel.ButtonOpenProject_name... item: ", item);
                //await win.timeout(100);
                store.state.setProject(item.projectId);
                //throw new Error("tän pitäis estää transitio"); // TODO: temp
            });
        }
    },
    projectOverviewPanel: {
        _initData() {
            return __awaiter(this, void 0, void 0, function* () {
                console.log(" *** init projectPanel, project: " + state.projectId);
                if (state.projectId) {
                    let projectFat = yield projectService.findProjectFat({ projectId: state.projectId, user: store.userPanel.currentUserName });
                    this.userTasks = projectFat.userTasks;
                    this.userPhases = projectFat.userPhases;
                    this.userTasks.forEach(t => t.name += " @" + t.assigneeFirstName + ""); // assignee mukaan nimeen
                    console.log(" *** init projectPanel, projectFat: ", projectFat);
                }
                console.log(" *** init projectPanel, done: ", this);
            });
        },
        get projectName() { return store.state.project ? store.state.project.projectId : null; },
        // projectName: "data.project.name", TODO: parempi ois jotenki näin tai jotain että tpl muuttuis: {{ store.projectOverviewPanel.projectName }} --> {{ project.name }}
        //get designErrors() { return store.state.project ? store.state.project.designErrors : null },
        userTasks: [],
        userPhases: [],
        Button_OpenInMonday_Openinmonday: (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            console.log("openInMonday, item: ", item);
            if (!item.pulseUrl)
                throw new Error("no item.pulseUrl");
            win.open(item.pulseUrl);
        }),
        "ButtonPhaseStatus_phaseStatusColor_phaseStatusColor": { __addAttributes: { ":class": "'akx-phase-status-'+item.statusSimple" } },
    },
    projectInfoForm: {},
    projectDesignErrorsPanel: {
        _initData() {
            return __awaiter(this, void 0, void 0, function* () {
                console.log(" *** init projectPanel, project: " + state.projectId);
                if (state.projectId) {
                    this.designErrors = yield win.callService("project_service", "findDesignErrors", { projectId: state.projectId });
                }
                console.log(" *** init projectPanel, done: ", this);
            });
        },
        get projectName() { return store.state.project ? store.state.project.projectId : null; },
        designErrors: null,
        "NaytetaanJosEiErroreita": { __addAttributes: { "v-if": "!_.size(store.projectDesignErrorsPanel.designErrors)" } },
        "Button_OpeninFigma": (evt, item) => { if (!item.figmaUrl)
            throw new Error("no figma url attached to this design error"); win.open(item.figmaUrl); },
        "Button_copyToClipboard_tag": (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            yield navigator.clipboard.writeText(item.tag);
            alert("Copied to clipboard!");
        }),
        "Button_Rundesignerrortesting": (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            let lrpStatus = yield win.callService("project_service", "validateDesign", { projectId: state.projectId });
            openLrpDialog(lrpStatus.processId);
        }),
        "Button_DisabloiJosErroreita_Generatetestversion": (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            let lrpStatus = yield win.callService("project_service", "generateToTest", { projectId: state.projectId });
            openLrpDialog(lrpStatus.processId);
        }),
    },
    /*
    ProjectsForm: {
      "_form_db_collection": null,
  
      projects: [
        { name: "Finnair xxx", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
        { name: "Finnair", templateType: "Impact Page", status: "Uusi"},
      ]
    },
     */
    userTasksPanel: {
        _initData() {
            return __awaiter(this, void 0, void 0, function* () {
                /* TODO: vittu store initData tehdään vikana prkl! nää siirretty sinne :-(
                this.userName = store.userPanel.currentUserName;
                this.userOverdueTasks = await callService("project_service", "findUserOverdueTasks", {user: store.userPanel.currentUserName});
                 */
                console.log(" *** TROLO initData *** store.userTasksPanel", new Error("trace")); // TODO: tätähän kutsutaan prkl 2 kertaa ... joo koska vuebasecomps akx-transition on paska!!!
            });
        },
        userName: null,
        userAllTasks: [],
        Button_OpenInMonday_monday: (evt, item) => __awaiter(void 0, void 0, void 0, function* () {
            win.open(item.pulseUrl);
        }),
        Button_MarkTaskDone_done(evt, item) {
            return __awaiter(this, void 0, void 0, function* () {
                if (confirm("Really mark '" + item.name + "' done???")) {
                    let res = yield projectService.markTaskAsDone({ user: store.userPanel.currentUserName, task: item });
                }
            });
        },
        Button_ReloadMondayTasks_Reloadtasks(evt, item) {
            return __awaiter(this, void 0, void 0, function* () {
                store.userTasksPanel.userAllTasks = yield projectService.findUserAllTasks({ user: store.userPanel.currentUserName, force: true });
                store.userTasksPanel.userAllTasks.forEach(t => t.name += " @" + t.assigneeFirstName + ""); // assignee mukaan nimeen
            });
        },
    },
    haemukaanformsPanel: {
        "_form_db_collection": null,
        haemukaanForms: [
            { fullName: "Eki Makkonen", email: "eki@makkonen.com", date: "1.1.2020" },
            { fullName: "Eki Makkonen", email: "eki@makkonen.com", date: "1.1.2020" },
            { fullName: "Eki Makkonen", email: "eki@makkonen.com", date: "1.1.2020" },
        ],
    },
    lrpStatusPanel: {
        _initData() {
            return __awaiter(this, void 0, void 0, function* () {
                this.processId = win.getUrlParam("processId");
                this.processStatus = "starting...?";
                if (this.processId) {
                    /*
                    let timer = setInterval(async () => {
                      //if (this.processId && !this.processFinalStatusesById[this.processId]) { // pollataan kunnes lrp done
                      let res = await win.callService("project_service", "getLongRunningProcessStatus", {processId: this.processId});
                      this.processStatus = res.processStatus;
                      //if (this.processStatus.match(/^(ok)|(error)/i)) {
                      if (res.processEnded) {
                        this.processFinalStatusesById[this.processId] = this.processStatus;
                        clearInterval(timer);
                      }
                      //}
                    }, 1000);
                     */
                    let poll = () => __awaiter(this, void 0, void 0, function* () {
                        try {
                            let res = yield win.callService("project_service", "getLongRunningProcessStatus", { processId: this.processId });
                            this.processStatus = res.processStatus;
                            if (res.processEnded) {
                                this.processFinalStatusesById[this.processId] = this.processStatus;
                                return;
                            }
                        }
                        catch (err) {
                            console.warn("getLongRunningProcessStatus: " + err);
                        }
                        setTimeout(poll, 1000);
                    });
                    poll();
                }
            });
        },
        processId: null,
        processStatus: null,
        processFinalStatusesById: {},
    },
};
// gener: end store
win.store = store;
/* vueappissa
if (win.getUrlParam) { // TODO: purkka tsekkaus että ollaan oikeessa ympissä, tää vois olla myös appin init...
  store.state._initData();
}
*/
// TODO: tällain vois toimia
/*
if (win.notimpl) {
  function mergeTpl(compname, tpladditions) {}
  mergeTpl("comp_panel_projectoverview___294_357", {
    //'[data-figma-name="Button-PhaseStatus_phaseStatus"]': {
    //  ":class": "'akx-phase-status-'+item.statusStripped"
    //},
    '[data-figma-name="Button-PhaseStatus_phaseStatus"]': `:class="'akx-phase-status-'+item.statusStripped"`,
    }
  );
}
 */
function openLrpDialog(processId) {
    win.clientRouter.navigateToView("LRPStatus-Dialog", undefined, undefined, "processId=" + processId);
}
